import { StickyHeader } from '../components/layout/StickyHeader';
import { HeroCarousel } from '../components/features/landing/HeroCarousel';
import { MeetEducatorsSection } from '../components/features/landing/MeetEducatorsSection';
import { WhyHallPassSection } from '../components/features/landing/WhyHallPassSection';
import { SuccessStoriesSection } from '../components/features/landing/SuccessStoriesSection';

export function LandingPage() {
    return (
        <div className="min-h-screen flex flex-col bg-brand-primary">
            {/* Sticky Header */}
            <StickyHeader />

            {/* Hero Section */}
            <main className="flex-grow flex flex-col items-center justify-between text-center px-4 relative overflow-hidden pt-24 pb-8 bg-transparent">
                {/* Title Section */}
                <div className="z-10 max-w-4xl space-y-8 relative">
                    <h1 className="text-6xl md:text-8xl font-bold text-brand-text tracking-tight drop-shadow-md">
                        Make the safe move.
                    </h1>
                </div>

                {/* Carousel Section - Takes available space */}
                <div className="flex-grow w-full flex items-center justify-center py-2 z-0">
                    <div className="w-full h-[500px] relative">
                        <HeroCarousel />
                    </div>
                </div>

                {/* Subtext Section - At the bottom */}
                <div className="z-20 px-4 relative pb-8">
                    <p className="text-2xl md:text-4xl text-white font-bold max-w-5xl mx-auto leading-relaxed drop-shadow-lg">
                        The dating app designed for teachers. Connect with confidence.
                    </p>
                </div>

                {/* Background Gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-brand-primary via-transparent to-transparent pointer-events-none z-[-1]" />
            </main>

            {/* Content Sections */}
            <MeetEducatorsSection />
            <WhyHallPassSection />
            <SuccessStoriesSection />

            {/* Footer */}
            <footer className="py-6 text-center text-brand-muted text-sm">
                <p>&copy; {new Date().getFullYear()} Hall Pass. All rights reserved.</p>
            </footer>
        </div>
    );
}
